import { render, staticRenderFns } from "./SettingBlockedUsers.vue?vue&type=template&id=cf97d7a0&"
import script from "./SettingBlockedUsers.vue?vue&type=script&lang=js&"
export * from "./SettingBlockedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports